"use client";

import { mergeProps, useRender } from "@base-ui/react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { useRef } from "react";

const containerVariants = cva("container mx-auto px-4 sm:px-6", {
  variants: {
    size: {
      sm: ["max-w-5xl"],
      md: ["max-w-7xl"],
      lg: ["max-w-8xl"],
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export interface ContainerProps
  extends useRender.ComponentProps<"div">, VariantProps<typeof containerVariants> {}

export const Container = ({ render, className, size, ...props }: ContainerProps) => {
  const internalRef = useRef<HTMLElement | null>(null);
  const defaultProps: useRender.ElementProps<"div"> = {
    className: cn(containerVariants({ className, size })),
  };

  const element = useRender({
    defaultTagName: "div",
    render,
    ref: internalRef,
    props: mergeProps<"div">(defaultProps, props),
  });

  return element;
};
